module.exports = __webpack_public_path__ + "img/fangcaodi.7645c3ba.jpg";